import React from 'react'
import styled from '@emotion/styled';
import css from '@emotion/css';
import smoothScroll from 'smoothscroll';
import { StyledImage } from '../../../../components/Print/StyledImage';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';

interface IArticleSidebarProps {
  isActive?: string;
  nextLinksData: { [key: string]: any }[];
  activeMsid: string;
  parentStory: { [key: string]: any }
  allArticleData: { [key: string]: any } | undefined
}

const ArticleSidebar = (props: IArticleSidebarProps) => {
  const { nextLinksData, activeMsid, parentStory, allArticleData } = props;
  const goToArticle = (e: { preventDefault: () => void; }, msid: string, dataPresent: boolean, index: number, wu: string) => {
    e.preventDefault();
    if (!dataPresent || msid === props.activeMsid) {
      return;
    }
    const elem: HTMLElement = document.querySelector(`[data-articlemsid="${msid}"]`) as HTMLElement;
    if (elem) {
      if (index !== 0) {
        analyticsWrapper('ga', 'send', 'event', 'WEB-Printedprimeshow', `Perpetual_widget_click_story_${index}`, `ps_story_${index}-${wu}`)
      }
      var scrollValue = elem.offsetTop;
      document.body.scrollTo({ top: scrollValue, behavior: 'smooth' });
    }
  };
  return (
    Array.isArray(nextLinksData) && nextLinksData.length ?
      <SidebarWrapper id="sidebarwrap">
        <Heading>You're Reading</Heading>
        {parentStory &&
          <ArticleList isActive={parentStory.msid === activeMsid ? 'true' : ''} onClick={(e: { preventDefault: () => void; }) =>
            goToArticle(e, parentStory.msid, true, 0, parentStory.wu)
          }>
            {parentStory.msid && parentStory.showImageInSideBar ? <StyledImage type='perpetualsidebarthumbnail'
              src={`https://static.toiimg.com/thumb/imgsize-12345,msid-${parentStory.msid},width-92,height-72,resizemode-4/${parentStory.msid}.jpg`}
            /> : <StyledImage type='perpetualsidebarthumbnail'
              src={`https://static.toiimg.com/photo/83033472.cms`}
            />
            }
            {parentStory.value && <Title>{parentStory.value}</Title>}
          </ArticleList>}
        {nextLinksData.map((val: { [key: string]: any }, index: number) => {
          return (
            <ArticleList isActive={val.id === activeMsid ? 'true' : ''} onClick={(e: { preventDefault: () => void; }) =>
              goToArticle(e, val.id, !!(allArticleData && allArticleData[val.id]), index + 1, val.wu)
            }>
              {val.id && val.image && val.image.id && val.image.version ? <StyledImage type='perpetualsidebarthumbnail'
                src={`https://static.toiimg.com/thumb/imgsize-12345,msid-${val.id},width-92,height-72,resizemode-4/${val.id}.jpg`}
              /> : <StyledImage type='perpetualsidebarthumbnail'
                src={`https://static.toiimg.com/photo/83033472.cms`}
              />}
              {val.hl && <Title>{val.hl}</Title>}
            </ArticleList>
          )
        })}
      </SidebarWrapper> : null
  )
}

const SidebarWrapper = styled.section`
  background: #FFFFFF;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
  border-radius: 12px; 
  border: 1px solid #F6F6F6;
  display: flex;
  flex-flow: column;
  width: 260px;
  padding:24px 16px;
  position: fixed;
  z-index:1;
  top: 135px;
  right: 0;
  margin: 0 32px;
  animation-duration: .5s;
  @media screen and (max-width:1000px)  {
    display: none;
  }
`
const Heading = styled.h5`
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  margin: 0 0 8px;
  text-transform: uppercase;
`

const ArticleList = styled.section<IArticleSidebarProps>`
  display: flex;
  align-items: center;
  padding:16px 0 ;
  cursor: pointer;
  border-bottom: 1px solid #f6f6f6;
  ${(props: IArticleSidebarProps) => props.isActive == "true" && css`
    background:#FFF5F6;
    margin: 0 -16px;
    padding: 16px;
    border:0;
    position: relative;
    p{
      font-weight: 600;
      color: #1A1A1A;
    }
    &:after{
      content: '';
      width: 0px;
      height: 0px;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid #FFF5F6;     
      left: -10px;
      transform: translate(0,-50%);
      top :50%;
      position: absolute;
    }
  `}
  &:last-child{
    border:0px;
  }
`
const Title = styled.p`
  font-size: 12px;
  font-weight:400;
  line-height: 16px;
  color: #595959;
  padding:0 0 0 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`

export default ArticleSidebar